module.exports = __webpack_public_path__ + "static/img/nav_bg.92639678.png";